import { useCallback, useEffect } from 'react';
import storeActions from '../actions';
import storeSelectors from '../selectors';
import { useAppDispatch } from 'store/hooks';
import { IApiGetListScreensInStoreParam } from 'modules/store/interfaces/api';

const useGetPlaylistsInStore = (storeId: string) => {
  const dispatch = useAppDispatch();
  const playlistsInStore = storeSelectors.getPlaylistListInStore();

  const mutate = useCallback((params: IApiGetListScreensInStoreParam) => {
      dispatch(storeActions.getListPlaylistsInStore.fetch({ ...params, storeId }));
    },
    [dispatch, storeId]
  );

  useEffect(() => {
    mutate({
      page: 1,
      size: 1000,
    });
  }, [mutate]);

  return {
    playlistsInStore,
    mutate,
  };
};

export default useGetPlaylistsInStore;
